<template>
  <div class="vip-head-confirm-popup">
    <div class="vip-head-confirm-popup-shade"></div>
    <div class="vip-head-confirm-popup-content">
      <p class="vip-head-confirm-popup-title">{{ languages.vipHeadGetTitle }}</p>
      <p class="vip-head-confirm-popup-tip">{{ languages.vipHeadGetTip }}</p>
      <p class="vip-head-confirm-popup-info">{{ getCurServerName() }} - {{ roleName }}</p>
      <div class="vip-head-confirm-popup-btn-wrap">
        <div class="vip-head-confirm-popup-cancel btn j-click-vip-head-confirm-cancel" @click="cancel">
          {{ languages.couponCancel }}
        </div>
        <div class="vip-head-confirm-popup-confirm btn j-click-vip-head-confirm-sure" @click="confirm">
          {{ languages.couponConfirm }}
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex'
export default {
  name: 'vipHeadConfirmPopup',
  props: ['languages'],
  computed: {
    ...mapState({
      serverList: state => state.serverList,
      serverId: state => state.serverId,
      roleName: state => state.roleName
    })
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    },
    getCurServerName() {
      let res = ''
      if (!this.serverList) return res
      for (let i in this.serverList) {
        if (this.serverList[i].ID == this.serverId) {
          res = this.serverList[i].NAME
          break
        }
      }
      return res
    }
  }
}
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.vip-head-confirm-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .4);
  }
  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    padding: 67px 47px 49px;
    background-size: 100% 100%;
    transform: translate(-50%, -50%);
    @psetbg ('common-popup.png', true, true);
  }
  &-title {
    margin-bottom: 39px;
    text-align: center;
    font-size: 36px;
    color: var(--global-tip-popup-title);
  }
  &-tip {
    margin-bottom: 20px;
    text-align: center;
    font-size: 25px;
    color: var(--global-tip-popup-title);
  }
  &-info {
    margin-bottom: 49px;
    text-align: center;
    font-size: 25px;
    color: var(--global-tip-popup-title);
  }
  &-btn-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background-size: cover;
    cursor: pointer;
    font-size: 36px;
    color: var(--global-tip-popup-btn);
  }
  &-cancel {
    cursor: pointer;
    @psetbg ('cancel.png');
  }
  &-confirm {
    cursor: pointer;
    @psetbg ('confirm.png');
  }
}
@media screen and (orientation: landscape) {
  .vip-head-confirm-popup {
    &-content {
      padding: 45px 32px 25px;
      @psetbg ('common-popup-hen.png', true, true);
    }
    &-title {
      margin-bottom: 19px;
      font-size: 25px;
    }
    &-tip {
      margin-bottom: 10px;
      font-size: 20px;
    }
    &-info {
      margin-bottom: 29px;
      font-size: 20px;
    }
    .btn {
      width: 181px;
      height: 53px;
      line-height: 53px;
      font-size: 24px;
    }
    &-cancel {
      cursor: pointer;
      @psetbg ('cancel-hen.png');
    }
    &-confirm {
      cursor: pointer;
      @psetbg ('confirm-hen.png');
    }
  }
}

</style>
